import React from 'react';
import { AnalyticsContext } from '@atlaskit/analytics-next';
import { extensionIdToAnalyticsAttributes } from './extensionIdToAnalyticsAttributes';
import { setupContextKeysFromSessionStorage } from './extensionLoadedFilter';
import { fg } from '@atlaskit/platform-feature-flags';

export const ForgeUIExtensionAnalyticsContext = ({
	extensionId,
	localId,
	children,
}: {
	children: React.ReactNode;
	extensionId: string;
	localId: string;
}): React.JSX.Element => {
	fg('forge-ui-new-event-filter') && setupContextKeysFromSessionStorage();

	return (
		<AnalyticsContext
			data={{
				forgeUIAttributes: {
					localId,
					...extensionIdToAnalyticsAttributes(extensionId),
				},
			}}
		>
			{children}
		</AnalyticsContext>
	);
};
